export const getCart = (page?: number) => ({
  type: "@saga/GET_CART",
  payload: page,
});
